import {useTranslationWithOverride} from "components/src/hook/UseTranslationWithOverride";
import {AccessibleSpinner} from "./AccessibleSpinner";

export const Loading = () =>
{
    const {t} = useTranslationWithOverride();

    return (
        <div>
            <AccessibleSpinner show={true} className="me-2"/>{t("common.loading")}
        </div>
    )
}
